import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
// Own modules
import { MenuModule } from './menu.module';
// Own services
import { CallService, ConfigService } from '../../../../src/app/shared/services';
// Should only have the bootstrapped component here
import { NavigationComponent } from './navigation/navigation.component';

@NgModule({
	declarations : [],
	bootstrap    : [NavigationComponent],
	imports      : [BrowserModule, MenuModule],
	providers    : [
		ConfigService,
		CallService,
		provideHttpClient(withInterceptorsFromDi())
	]
})
export class AppModule {
}
